import createRoutingSlice from "./routing";
import { RoutingSlice } from "./routing.types";

export type { RoutingSlice };
export default createRoutingSlice;
